const OSS = require('ali-oss');
import http from '../axios/http'
import { Message, Loading } from 'element-ui'

let loading;

 //获取oss参数
function getAliParams() {
    return new Promise((resolve, reject) => {
        http('common/oss/web-oss', {}, 'get').then(data => {
            resolve(data);
        })
    });
}

const headers = {
    // 指定该Object被下载时的网页缓存行为。
    "Cache-Control": "no-cache",
    // 指定该Object被下载时的名称。
    "Content-Disposition": "example.txt",
    // 指定该Object被下载时的内容编码格式。
    "Content-Encoding": "utf-8",
    // 指定过期时间，单位为毫秒。
    "Expires": "1000",
    // 指定Object的存储类型。
    "x-oss-storage-class": "Standard",
    // 指定Object标签，可同时设置多个标签。
    "x-oss-tagging": "Tag1=1&Tag2=2",
    // 指定初始化分片上传时是否覆盖同名Object。此处设置为true，表示禁止覆盖同名Object。
    "x-oss-forbid-overwrite": "true",
};

export default async function updateAliOSS(filename, file) {
    let params = {};
    let err = false;
    await getAliParams().then(data => {
        if(data.code == 0){
            loading = Loading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            params = data.data;
        }else{
            err = true;
            console.log(data);
            Message.error('文件上传失败，请稍后重试!'); 
        }
    })
    if(err) {
        return new Promise(async (resolve, reject) => {
            //上传失败
            if(loading){
                loading.close();
                loading = '';
            }
            Message.error('文件上传失败，请稍后重试!'); 
            reject();
        });
    }
    return new Promise(async (resolve, reject) => {
        // 实例化一个上传客户端
        const client = new OSS({
            region: params.region,
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: params.access_key,
            accessKeySecret: params.access_secret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: params.token,
            // 填写Bucket名称。
            bucket: params.bucket,
            refreshSTSToken: true,
            refreshSTSTokenInterval: 3600000, // 刷新间隔为1小时
            // expiration: params.expiration
        })
        // //简单上传
        // const result = await client.put(filename, file);
        // resolve(result);
        
        try {
            let options = {
                // 获取分片上传进度、断点和返回值。
                progress: (p, _checkpoint) => {
                    // const e = {};
                    // e.percent = parseInt(p * 100);
                    // console.log(p)
                  },
    
                // 设置并发上传的分片数量。
                parallel: 10,
                // 设置分片大小。默认值为1 MB，最小值为100 KB。
                partSize: 1024 * 1024 * 10,
                timeout: 120000
            }
            const {
                res: resp
            } = await client.multipartUpload(filename, file, options)
            // return resp.requestUrls
            if(loading){
                loading.close();
                loading = '';
            }
            resolve(resp.requestUrls)
        } catch (e) {
            if(loading){
                loading.close();
                loading = '';
            }
            console.log(e);
            Message.error('文件上传失败，请稍后重试!'); 
            reject();
        }

    });
    
    
    
}



// WEBPACK FOOTER //
// ./src/js/uploadAliOss.js